/**
 * Клиентская валидация форм. Сообщения на русском.
 * Возвращают строку с ошибкой или null, если поле валидно.
 */

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateEmail(value) {
  const v = (value || "").trim();
  if (!v) return "Введите email";
  if (!EMAIL_RE.test(v)) return "Похоже, email введён с ошибкой";
  return null;
}

export function validatePassword(value) {
  const v = value || "";
  if (!v) return "Введите пароль";
  if (v.length < 6) return "Пароль должен быть не короче 6 символов";
  return null;
}

export function validateName(value) {
  const v = (value || "").trim();
  if (!v) return "Введите имя";
  if (v.length < 2) return "Имя слишком короткое";
  if (v.length > 40) return "Имя слишком длинное";
  return null;
}

export function validatePasswordConfirm(password, confirm) {
  if (!confirm) return "Повторите пароль";
  if (password !== confirm) return "Пароли не совпадают";
  return null;
}

/**
 * Валидация даты рождения. Принимает строку "YYYY-MM-DD" из <input type="date">.
 * Возраст должен быть в разумных пределах (3–120 лет) — те же границы, что
 * на бэкенде (api-user signup / birth-date).
 */
export function validateBirthDate(value) {
  const v = (value || "").trim();
  if (!v) return "Укажите дату рождения";
  if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) return "Некорректная дата";
  const d = new Date(v + "T00:00:00");
  if (Number.isNaN(d.getTime())) return "Некорректная дата";
  const today = new Date();
  let age = today.getFullYear() - d.getFullYear();
  const m = today.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age--;
  if (d > today) return "Дата рождения не может быть в будущем";
  if (age < 3 || age > 120) return "Проверьте дату рождения";
  return null;
}

/** Валидация пола — должен быть выбран один из вариантов. */
export function validateGender(value) {
  if (value !== "male" && value !== "female") return "Выберите пол";
  return null;
}
